import { useApolloClient } from '@apollo/client';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { executeGraphQLMutation, executeGraphQLQuery } from '../../common/executeGraphQLQuery';
import { CHECK_ASSIGN_USER, STANDALONE_ORCR_STATUS } from '../../config/constants';
import { GET_USER_LIST } from '../../services/role.gql';
import { getLeadRemarks } from '../../store/action/allAction';
import Loader from '../elements/Loader';
import Modal from '../elements/Modal';
import Pagination from '../elements/pagination';
import DocsPreviewORCR from './DocsPreviewORCR';
import LeadVerification from './LeadVerification';
import UploadAgentFee from './UploadAgentFee';
import { STANDALONE_UPDATE_LEAD_ORCR, UPDATE_LEAD_ASSIGNED_TO_STANDALONE_ORCR } from '../../services/standalone-orcr.gql';
import GenerateReport from '../ucf-orcr-lead-list/GenerateReport';
import formFields from './formFields/AddApplication.json';
import { getKeysData } from '../../common/Helper';
const VEHICLE_DETAILS = formFields.VEHICLE_DETAILS;

const LeadListTable = ({ leads, t, isLoading, onPaginate, totalPage, currentPage, getLeadList, getLeadsInput, paginationInput, statuses }) => {
    const [isviewRemarks, setIsviewRemarks] = useState('');
    const [showORCRmodel, setShowORCRmodel] = useState(false);
    const [showAgentFeeModel, setShowAgentFeeModel] = useState(false);
    const [vehicleModal, setVehicleModal] = useState(false);
    const [vehiclePlateModal, setVehiclePlateModal] = useState(false);
    const [activeLead, setActiveLead] = useState({});
    const [orcrDocs, setOrcrDocs] = useState([]);
    const [lead_detail, setLeadDetails] = useState({});
    const [leadList, setLeadList] = useState([]);
    const [showVerificationModel, setShowVerificationModel] = useState(false);
    const [showSummaryModal, setShowSummaryModal] = useState(false);
    const [editVehicleDetails, setEditVehicleDetails] = useState(false);
    const client = useApolloClient();
    let { remarksHistory, opsExecutiveList } = useSelector(({ lead, masterdata }) => {
        return {
            remarksHistory: lead.remarksHistory || [],
            opsExecutiveList: masterdata.opsExecutiveList?.map(({ id, label }) => ({ value: id, label })) || [],
        };
    });
    const user_information = useSelector((state) => state.user.user_information);
    const UserInfo = JSON.parse(user_information);

    if (UserInfo?.role_id.length === 1 && UserInfo?.role_id.includes(2)) opsExecutiveList = opsExecutiveList.filter(data => data?.value === UserInfo?.id);
    useEffect(() => {
        const fetchData = async () => {
            await getUserList();
        };
        fetchData();
    }, []);

    useEffect(() => {
        setLeadList(leads);
    }, [leads]);
    useEffect(() => {
        if (remarksHistory.length && isviewRemarks !== '') {
            setIsviewRemarks('');
        }
    }, [remarksHistory, isviewRemarks]);

    const dispatch = useDispatch();

    const toggleModalBoxremark = (lead) => {
        if (Object.keys(lead).length) {
            setIsviewRemarks(lead.id);
            setShowORCRmodel(true);
            dispatch(getLeadRemarks({ lead_id: lead.id, source: 'WEB' }, client));
            setIsviewRemarks('');
        } else {
            setIsviewRemarks('');
            setShowORCRmodel(false);
            setShowAgentFeeModel(false);
            setOrcrDocs([]);
        }
    };

    const getUserList = async () => {
        let user_list = [],
            userlist = [];
        await executeGraphQLQuery(GET_USER_LIST(5, 6), client)
            .then((response) => {
                if (response && response.data && response.data.get_user_list) {
                    user_list = response.data.get_user_list.filter((obj) => obj.status === '1');
                    user_list &&
                        user_list.map((v) => {
                            userlist.push({ value: v.user_id, label: v.name, role_id: v.role_assigned_ids });
                            return v;
                        });
                }
            })
            .catch((error) => { });
    };

    const assignToUser = (e, lead_id) => {
        if (!e.value) return;
        if (!window.confirm('Are you sure want to assign?')) return;
        let index = leadList.findIndex((data) => data.id === +lead_id);
        if (leadList?.[index]?.lead_assigned_to === e?.id) {
            toast.error('Loan ID already assigned to this User.');
            return;
        }
        let variables = {
            api_called_by: 'web',
            user_id: UserInfo?.id || 0,
            role_id: UserInfo?.role_id?.[0] || 0,
            lead_id,
            lead_assigned_to: e?.value,
        };
        executeGraphQLMutation(UPDATE_LEAD_ASSIGNED_TO_STANDALONE_ORCR(), variables, client)
            .then((res) => {
                if (res?.data?.standalone_update_lead_assigned_to_orcr) {
                    toast.success(res?.data?.standalone_update_lead_assigned_to_orcr?.message);
                    getLeadList({
                        getLeadsInput,
                        paginationInput
                    });
                } else {
                    toast.error('Error');
                }
            })
            .catch((err) => {
                toast.error(err.toString().replace('ApolloError:', ''));
            });
    };
    const saveUpdatedDetails = () => {
        let variables = {
            user_id: UserInfo?.id || 0,
            updateLeadInput: {
                ...getKeysData(lead_detail, ["lead_id", "owner_name", "registration_number", "make", "model", "variant", "make_year", "engine_number", "chassis_number", "fuel_type", "transmission", "color", "seating_capacity", "address", "plate", "mv_file_no"]),
                seating_capacity: +lead_detail?.seating_capacity,
                make_year: +lead_detail?.make_year,
            }
        };

        const mvFileNo = variables.updateLeadInput.mv_file_no;
        if (mvFileNo) {
            const rule = VEHICLE_DETAILS.find(f => f.name === "mv_file_no");
            if (rule?.validations) {
                const regexMatch = rule.validations.match(/^matchRegexp:(.*)$/);
                if (regexMatch) {
                    const pattern = new RegExp(regexMatch[1]);
                    if (!pattern.test(mvFileNo)) {
                        toast.error(rule.validationError || "Invalid MV File Number");
                        return;
                    }
                }
            }
        }

        executeGraphQLMutation(STANDALONE_UPDATE_LEAD_ORCR, variables, client)
            .then((res) => {
                if (res?.data?.standalone_update_lead_orcr) {
                    toast.success(res?.data?.standalone_update_lead_orcr?.message);
                    getLeadList({
                        getLeadsInput,
                        paginationInput
                    });
                    toggleEditFields();
                    showVehicleDetails({});
                    toggleVehiclePlateModal({});
                } else {
                    toast.error('Error');
                }
            })
            .catch((err) => {
                if (err.toString().replace('ApolloError:', '')?.includes("Plate number already exists for lead id")) {
                    setLeadDetails(prev => ({
                        ...prev,
                        is_duplicate_plate: true
                    }));
                }
                toast.error(err.toString().replace('ApolloError:', ''));
            })
            .finally(() => {
            });
    };

    const toggleEditFields = () => {
        setEditVehicleDetails(!editVehicleDetails);
    };

    const showIFDocs = (doc_ids, lead) => {
        if (Object.keys(lead).length) {
            let lead_docs = lead?.lead_docs?.filter(docs => doc_ids.includes(docs?.doc_id)) || [];
            setOrcrDocs(lead_docs);
            setShowORCRmodel(true);
        } else {
            setOrcrDocs([]);
            setShowORCRmodel(false);
        }
    };

    const showVehicleDetails = (lead) => {
        if (Object.keys(lead).length) {
            let lead_details = lead?.lead_detail || {};
            setLeadDetails({ ...lead_details, status_id: lead?.status_id });
            setVehicleModal(true);
            document.body.classList.add('overflow-hidden');
        } else {
            setLeadDetails({});
            setVehicleModal(false);
            document.body.classList.remove('overflow-hidden');
        }
    };
    const generateVerificationReport = (lead) => {
        if (Object.keys(lead)?.length) {
            setActiveLead(lead);
            setShowSummaryModal(true);
        }
    };
    const hideSummaryReportModal = () => {
        setShowSummaryModal(false);
        setActiveLead({});
    };

    const uploadPaymentProof = (lead) => {
        if (Object.keys(lead)?.length) {
            setActiveLead(lead);
            setShowAgentFeeModel(true);
        } else {
            setShowAgentFeeModel(false);
        }
    };

    const uploadVerificationDocs = (lead) => {
        if (Object.keys(lead)?.length) {
            setActiveLead(lead);
            setShowVerificationModel(true);
        }
    };

    const hideVerificationDocsModel = () => {
        setShowVerificationModel(false);
        setActiveLead({});
    };


    const handleInputChange = (state, field, value) => {
        const newData = {};
        if (field === "plate" && lead_detail?.is_duplicate_plate) {
            newData.is_duplicate_plate = false;
        }
        state(prev => ({
            ...prev,
            ...newData,
            [field]: value
        }));
    };

    const hideVehicleDocsModal = () => {
        document.body.classList.remove('overflow-hidden');
        setVehicleModal(false);
        setLeadDetails({});
    };

    const toggleVehiclePlateModal = (lead = {}) => {
        if (Object.keys(lead).length) {
            let lead_details = lead?.lead_detail || {};
            setLeadDetails({ ...lead_details, status_id: lead?.status_id });
            setVehiclePlateModal(true);
            document.body.classList.add('overflow-hidden');
        } else {
            setLeadDetails({});
            setVehiclePlateModal(false);
            document.body.classList.remove('overflow-hidden');
        }
    };

    return (
        <div>
            <div className="lead-list-standalone-table ">
                <table>
                    <thead>
                        <tr>
                            <th>Apps ID</th>
                            <th>Received Date</th>
                            <th>Plate Number</th>
                            <th>Vehicle Details</th>
                            <th>Agent Fee</th>
                            <th>ORCR</th>
                            <th>Upload Verification <br /> Docs</th>
                            <th>Summary <br /> Report</th>
                            <th>Status</th>
                            <th>Ops Executive</th>
                        </tr>
                    </thead>
                    <tbody>
                        {leadList?.map((lead) => {
                            if (lead?.lead_detail?.plate) lead.lead_detail.plate_number = lead?.lead_detail?.plate || '';
                            let lead_vehicle_detail = `${lead?.lead_detail?.make || ''} ${lead?.lead_detail?.model || ''
                                } ${lead?.lead_detail?.transmission || ''} ${lead?.lead_detail?.fuel_type || ''}`;
                            return (
                                <tr key={lead.id}>
                                    <td>
                                        {' '}

                                        {lead.app_id}{' '}

                                    </td>
                                    <td>{moment(new Date(lead?.created_date)).add(8, 'hours').format('D MMM, Y') || '-'}</td>
                                    <td>{lead?.lead_detail?.plate || '-'} {lead?.status_id === STANDALONE_ORCR_STATUS.RECIEVED ? <button onClick={() => { toggleVehiclePlateModal(lead); }} className="link-button" style={{ textAlign: 'left' }}><i className='ic-edit'></i></button> : <></>}
                                    </td>

                                    <td>
                                        <ul>
                                            <li>
                                                {lead_vehicle_detail}
                                            </li>
                                            <li>
                                                <button onClick={() => { showVehicleDetails(lead); }} className="link-button" style={{ textAlign: 'left' }}>View Vehicle Details</button>
                                            </li>
                                        </ul>
                                    </td>
                                    <td>
                                        <ul>
                                            {lead?.lead_detail?.agent_fee && <li>₱ {lead?.lead_detail?.agent_fee}</li>}
                                            {lead?.lead_detail?.agent_fee ?
                                                <li>
                                                    <button onClick={() => { showIFDocs([3], lead); }} className="link-button">View Proof</button>
                                                </li> :
                                                <li>
                                                    <button disabled={CHECK_ASSIGN_USER(lead?.lead_assigned_to)} onClick={() => { uploadPaymentProof(lead); }} className="link-button">Upload Proof</button>
                                                </li>
                                            }
                                        </ul>
                                    </td>

                                    <td>
                                        <ul>
                                            <li>
                                                <button onClick={() => { showIFDocs([1], lead); }} className="link-button">View CR</button>
                                            </li>
                                            <li>
                                                <button onClick={() => { showIFDocs([2], lead); }} className="link-button">View OR</button>
                                            </li>
                                        </ul>
                                    </td>
                                    <td>
                                        <ul>
                                            <li>
                                                {lead?.status_id === STANDALONE_ORCR_STATUS.RECIEVED ?
                                                    <button disabled={CHECK_ASSIGN_USER(lead?.lead_assigned_to)} onClick={() => { uploadVerificationDocs(lead); }} className="link-button">Click Here <br></br> to Upload</button> :
                                                    <button onClick={() => { uploadVerificationDocs(lead); }} className="link-button">View Doc</button>
                                                }
                                            </li>
                                        </ul>
                                    </td>

                                    <td>
                                        <ul>
                                            <li>
                                                {!lead?.lead_docs.some(doc => parseInt(doc.doc_id) === 7)
                                                    ? <button disabled={!lead?.lead_docs.some(doc => parseInt(doc.doc_id) === 4) || CHECK_ASSIGN_USER(lead?.lead_assigned_to)} onClick={() => { generateVerificationReport(lead); }} className="link-button">Generate <br></br> Report</button>
                                                    : <button onClick={() => { showIFDocs([7], lead); }} className="link-button">View Report</button>
                                                }
                                            </li>
                                        </ul>
                                    </td>

                                    <td style={{ "color": lead?.status_id === STANDALONE_ORCR_STATUS.VERIFIED ? "blue" : lead?.status_id === STANDALONE_ORCR_STATUS.NOT_VERIFIED ? "red" : "" }}>{statuses?.filter((st) => +st?.id === +lead?.status_id)?.[0]?.value || '-'}</td>

                                    <td>
                                        <fieldset className="single-select">
                                            <div
                                                className="material"
                                                title={
                                                    opsExecutiveList.filter(({ value }) => value === lead?.lead_assigned_to)?.[0]
                                                        ?.name || '-'
                                                }
                                            ></div>
                                            <Select
                                                className="react-select-table"
                                                classNamePrefix="react-select-table"
                                                placeholder={'Select Assign To'}
                                                options={opsExecutiveList || []}
                                                name={'lead_assigned_to'}
                                                optionLabel={'name'}
                                                optionValue={'id'}
                                                value={opsExecutiveList.filter(({ value }) => value === lead?.lead_assigned_to)}
                                                onChange={(e) => assignToUser(e, lead.id)}
                                                aria-label="Lead assigned to"
                                                isDisabled={lead?.status_id !== STANDALONE_ORCR_STATUS.RECIEVED}
                                            //isDisabled={!UserInfo?.role_id.includes(1)}
                                            />
                                        </fieldset>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>

                <p className="align-center-no-record">
                    {leadList?.length < 1 && 'No record found'}
                </p>
            </div>
            {isLoading ? <Loader /> : null}
            <Pagination
                pageCount={totalPage}
                activePage={currentPage || 1}
                onPaginate={onPaginate}
            />



            {showORCRmodel ? (
                <div className="view-timeline-popup image-timeline-popup">
                    <Modal
                        show={showORCRmodel}
                        handleClose={() => {
                            toggleModalBoxremark({});
                        }}
                    >
                        <div className="modal-header">
                            {orcrDocs?.some(doc => doc.doc_id === 1) ? (
                                <h2>CR Docs</h2>
                            ) : orcrDocs?.some(doc => doc.doc_id === 7) ? (
                                <h2>Summary Report</h2>
                            ) : (
                                <h2>{orcrDocs?.some(doc => doc.doc_id === 2) ? "OR" : "Agent Fee "} Docs</h2>
                            )}
                        </div>
                        <div className="modal-body m-md-t">
                            <DocsPreviewORCR docs={orcrDocs} />
                        </div>
                    </Modal>
                </div >
            ) : (
                ''
            )}
            {
                showAgentFeeModel ? (
                    <div className="view-timeline-popup image-timeline-popup">
                        <Modal
                            show={showAgentFeeModel}
                            handleClose={() => {
                                toggleModalBoxremark({});
                            }}
                        >
                            <div className="modal-header">
                                <h2>Upload Agent Fee</h2>
                            </div>
                            <div className="modal-body m-md-t">
                                <UploadAgentFee lead={activeLead} toggleModalBoxremark={toggleModalBoxremark} getLeadList={getLeadList} user_id={UserInfo?.id} getLeadsInput={getLeadsInput} paginationInput={paginationInput} />
                            </div>
                        </Modal>
                    </div>
                ) : (
                    ''
                )
            }

            {
                showVerificationModel ? (
                    <div className="view-timeline-popup image-timeline-popup">
                        <Modal show={true} handleClose={() => hideVerificationDocsModel()}>
                            <div className="modal-header">
                                {activeLead.status_id === STANDALONE_ORCR_STATUS.RECIEVED ? <h2>Upload Verification Proof</h2> : <h2>Verification Documents</h2>}
                                {activeLead.lead_docs.filter((doc) => doc?.doc_id.toString() === '4').length === 0 && activeLead.status_id !== STANDALONE_ORCR_STATUS.RECIEVED
                                    && <><br /><h4>No Docs Uploaded</h4></>
                                }
                            </div>
                            <div className="modal-body m-md-t h-300">
                                <LeadVerification lead={activeLead} hideVerificationDocsModel={hideVerificationDocsModel} getLeadList={getLeadList} user_id={UserInfo?.id} getLeadsInput={getLeadsInput} paginationInput={paginationInput} />
                            </div>
                        </Modal>
                    </div>
                ) : ''
            }

            {
                vehiclePlateModal ? (
                    <div className="view-timeline-popup image-timeline-popup standalone-vehicle-plate-update">
                        <Modal show={true} handleClose={() => toggleVehiclePlateModal()}>
                            <div className="modal-header">
                                <h2>Edit Plate Number</h2>
                            </div>
                            <div className="modal-body vehicle-details-body">
                                <div className="vehicle-details-grid">
                                    <input
                                        type="text"
                                        className="field-input"
                                        value={lead_detail?.plate || ""}
                                        onChange={(e) => handleInputChange(setLeadDetails, "plate", e.target.value)}
                                    />
                                    {lead_detail?.is_duplicate_plate ? <label className=''>Plate number already exists</label> : <></>}
                                </div>
                            </div>
                            <div className="modal-footer p-lg-t">
                                {lead_detail?.status_id === STANDALONE_ORCR_STATUS.RECIEVED && lead_detail?.plate ?
                                    <button aria-label="save naxt" type="submit" className="btn-primary" onClick={() => saveUpdatedDetails()}>
                                        Save
                                    </button> : <span className="span-disabled">Save</span>}
                            </div>
                        </Modal>
                    </div>
                ) : ''
            }
            {
                vehicleModal ? (
                    <div className="view-timeline-popup image-timeline-popup standalone-vehicle-update">
                        <Modal show={true} handleClose={() => hideVehicleDocsModal()}>
                            <div className="modal-header">
                                <h2>Vehicle Details</h2>
                            </div>
                            <div className="modal-body vehicle-details-body">
                                <div className="vehicle-details-grid">
                                    {VEHICLE_DETAILS?.map((field) => (
                                        <React.Fragment key={field?.name}>
                                            <label className="field-label">{field?.label}:</label>
                                            {editVehicleDetails ? (
                                                ["text", "number"]?.includes(field?.type) ?
                                                    <input
                                                        type={field?.type}
                                                        className="field-input"
                                                        value={lead_detail?.[field?.name] || ""}
                                                        onChange={(e) =>
                                                            handleInputChange(setLeadDetails, field?.name, e.target.value)
                                                        }
                                                    /> : <textarea
                                                        name={field?.name}
                                                        id={field?.id}
                                                        placeholder=" "
                                                        class="form-input"
                                                        rows="3"
                                                        onChange={(e) =>
                                                            handleInputChange(setLeadDetails, field?.name, e.target.value)
                                                        }
                                                        // onBlur={(e) => blurHandler('remarks', e)}
                                                        value={lead_detail?.[field?.name] || ""}
                                                    ></textarea>
                                            ) : (
                                                <span className="field-text">
                                                    {lead_detail?.[field?.name] || "—"}
                                                </span>
                                            )}
                                        </React.Fragment>
                                    ))}
                                </div>
                            </div>
                            <div className="modal-footer btn-save-remarks p-lg-t">
                                {lead_detail?.status_id === STANDALONE_ORCR_STATUS.RECIEVED ?
                                    editVehicleDetails ? (
                                        <button aria-label="save naxt" type="submit" className="btn-primary" onClick={() => saveUpdatedDetails()}>
                                            Save
                                        </button>
                                    ) : (
                                        <button aria-label="save naxt" type="submit" className="btn-primary" onClick={() => toggleEditFields()}>
                                            Edit Fields
                                        </button>
                                    )
                                    : <></>}
                            </div>
                        </Modal>
                    </div>
                ) : ''
            }

            {
                showSummaryModal ? (
                    <div className="view-timeline-popup image-timeline-popup" style={{ width: '1000%' }}>
                        <Modal show={true} handleClose={() => hideSummaryReportModal()}>
                            <div className="modal-header">
                                <h2>Vehicle Details</h2>
                            </div>
                            <div className="modal-body m-md-t h-300">
                                <GenerateReport lead={activeLead} hideVerificationDocsModel={hideSummaryReportModal} getLeadList={getLeadList} user_id={UserInfo?.id} getLeadsInput={getLeadsInput} paginationInput={paginationInput} apiCalledBy='standaloneorcr' />
                            </div>
                        </Modal>
                    </div>
                ) : ''
            }


        </div >
    );
};
export default LeadListTable;
